import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EventRecommendationFilter, EventRecommendations, EventRecommendation } from './recommendation.types';
import { getParams } from '../../common/common.func';

@Injectable()
export class RecommendationService {
	private readonly recommendationUrl = 'api/recommendations';

	constructor(private _http: HttpClient) { }

	getRecommendations(eventRecommendationFilter?: EventRecommendationFilter): Promise<EventRecommendations> {
		return this._http.get<EventRecommendations>(this.recommendationUrl, { params: getParams(eventRecommendationFilter) })
			.toPromise();
	}

	getRecommendation(recommendationId: number): Promise<EventRecommendation> {
		return this._http.get<EventRecommendation>(`${this.recommendationUrl}/${recommendationId}`)
			.toPromise();
	}
}
